import { geoforgeStore } from '@/components/providers/geoforge-store-provider';
import { clearCachedToken } from '@/utils/supabase/token-manager';

export type { CurrentUser } from '@/lib/stores/slices/user.slice';

/**
 * Initialize user data in the store after login
 * Call this function after successful login
 */
export async function initializeUserInStore() {
  // Drop any token cached for a previous session before hydrating the new user,
  // so an account switch on the same tab can't reuse the prior user's token.
  clearCachedToken();
  try {
    await geoforgeStore.getState().initializeUser();
  } catch (error) {
    console.error('Error initializing user in store:', error);
  }
}

/**
 * Clear user data from store on logout
 */
export function clearUserFromStore() {
  geoforgeStore.getState().clearUser();
  // The HttpOnly session cookie is about to be cleared by signOut(); drop the
  // in-memory access token too so a signed-out tab can't keep using it.
  clearCachedToken();
}
